import React from 'react';

export default function BrownGlassesSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="30.94,25.43 2.0,25.43 2.0,14.57 30.94,14.57" fill="#4E3124" />
      <polygon points="9.06,25.34 2.0,21.81 2.0,16.38 9.06,19.91" fill="#080503" opacity="0.95" />
      <polygon points="38.0,25.34 30.94,21.81 30.94,16.38 38.0,19.91" fill="#080503" opacity="0.95" />
    </svg>
  );
}
